// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"559":"2d2ba174","787":"88856814"}[chunkId] + ".chunk.js";
};